<!--
  自定义模态窗,采用flex布局
-->
<template>
  <div class="model-max-box" @click="e => e.cancelBubble = true">
    <slot />
  </div>
</template>

<script>
  export default {
    name: "ModelPop"
  }
</script>

<style scoped>
  .model-max-box {
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    justify-content: center;
    background: rgba(0,0,0,.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/assembly/ModelPop.vue